/**
 * Urdu translations for Availability domain
 */

import type { AvailabilityTranslation } from './types'

export const availabilityTranslationUr: AvailabilityTranslation = {
  admin: {
    availability: {
      title: 'فیکٹری کی دستیابی',
      subtitle: 'ترتیب دیں کہ ہر فیکٹری میں کون سی مصنوعات دستیاب ہیں',
      totalFactories: 'فیکٹریاں',
      totalVariants: 'اقسام',
      available: 'دستیاب',
      unavailable: 'غیر دستیاب',
      coverage: 'کوریج',
      coverageDesc: 'کل مجموعوں میں سے',
      matrix: 'دستیابی میٹرکس',
      factory: 'فیکٹری',
      variant: 'قسم',
      noData: 'کوئی فیکٹری یا اقسام دستیاب نہیں',
    },
  },
}
